import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { TrashIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { IconButton, Text } from '@reveni-io/reveni-ui'

import FilterTypeSelector from '@/common/components/FilterTypeSelector/FilterTypeSelector'

import * as Styles from './styles'

const FilterCard = forwardRef(
  (
    {
      type,
      value,
      onChangeType,
      onChangeValue,
      onDelete,
      chipContent,
      availableFilterTypes,
      sections,
      filterFields,
      fieldProps,
    },
    ref
  ) => {
    const theme = useTheme()
    const { t } = useTranslation()

    const getField = () => filterFields[type]?.({ value, onChangeValue, fieldProps }) ?? null

    return (
      <Styles.Card ref={ref}>
        <Styles.Header>
          <Styles.TitleAndChip>
            <Text type="allCapsM" color={theme.colors.text.subtle}>
              {t('Filtro')}
            </Text>
            {chipContent}
          </Styles.TitleAndChip>
          {onDelete && (
            <IconButton
              variant="text"
              onClick={onDelete}
              icon={<TrashIcon size={24} data-testid="delete-filter-icon" />}
            />
          )}
        </Styles.Header>
        <Styles.Fields>
          <FilterTypeSelector
            value={type}
            onChange={onChangeType}
            filterTypes={availableFilterTypes}
            sections={sections}
          />
          {getField()}
        </Styles.Fields>
      </Styles.Card>
    )
  }
)

FilterCard.displayName = 'FilterCard'

export default FilterCard
